import catalogData from "./genie-catalog.generated.json";
import type { PublicGenieCatalogEntry } from "@/types/discovery-catalog";

const catalog = catalogData as PublicGenieCatalogEntry[];

export function getPublicGenieById(id: string): PublicGenieCatalogEntry | undefined {
  return catalog.find((genie) => genie.id === id);
}

export function getAllPublicGenies(): PublicGenieCatalogEntry[] {
  return catalog;
}

export function getPublicGeniesForIndustry(industryId: string): PublicGenieCatalogEntry[] {
  return catalog
    .filter((genie) => genie.industryId === industryId)
    .sort((a, b) => (a.order ?? 99) - (b.order ?? 99));
}

export function getPublicGeniesForSubcategory(subcategoryId: string): PublicGenieCatalogEntry[] {
  return catalog
    .filter((genie) => genie.subcategoryId === subcategoryId)
    .sort((a, b) => (a.order ?? 99) - (b.order ?? 99));
}

export function searchPublicGenies(query: string): PublicGenieCatalogEntry[] {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return catalog;

  return catalog.filter((genie) =>
    [
      genie.name,
      genie.role,
      genie.description,
      genie.industryId,
      genie.subcategoryId,
      ...genie.config.tags,
    ].some((value) => value.toLowerCase().includes(normalizedQuery)),
  );
}
